import {io} from 'socket.io-client';
import axios from 'axios';
import {appConfig} from '@config';

export type IResponse<T> = {
	success: true;
	result: T
} | {
	success: false,
	error: string
};


let socket = io(appConfig.socket.url, {
	auth: {
		token: localStorage.getItem('rezvan_token')
	},
	autoConnect: false
});
export default socket;

socket.on('connect', () => {
	// console.log('connect');
});

socket.on('connect_error', (err) => {
	if (err.message === 'User isn\'t login') {
		axios({
			url: `${appConfig.base.url}user`,
			method: 'post'
		}).then(res => {
			localStorage.setItem('rezvan_token', res.data.result);
			// @ts-ignore
			socket.auth.token = res.data.result;
			socket.connect();
		}).catch(err => {
			console.log(err);
		});
	}
});
